import { render } from "./UiScrollToTop.vue?vue&type=template&id=d379b81c&ts=true&lang=pug"
import script from "./UiScrollToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiScrollToTop.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__